import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec59c534"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "descriptions" }
const _hoisted_2 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: _normalizeClass({ isFull: item.isFull })
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["content", {
        'text-left': item.align === 'left',
        'text-right': item.align === 'right',
        'text-center': !item.align || item.align === 'center'
      }])
        }, _toDisplayString(_ctx.info[item.key] ?? '-'), 3)
      ], 2))
    }), 128))
  ]))
}